import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {isSmallScreen} from "../../../../UtilsLib";
import {autoenhance} from "../../../../theme/StyleConstants.js";


export class UserDashboardTabStyle extends StyleSheet {
    @styleRule
    container = {
        minHeight: "100%",
        padding: "12px 24px",
        fontSize: isSmallScreen() ? this.themeProps.FONT_SIZE_SMALL : this.themeProps.FONT_SIZE_NORMAL,
    };

    @styleRule
    button = {
        width: 191,
    };

    @styleRule
    textSection = {
        margin: "8px 0",
        ":>last-child": {
            marginBottom: 0,
        }
    };

    @styleRule
    cancel = {
        cursor: "pointer",
        marginTop: 8,
        color: this.themeProps.ERROR_COLOR,
        ":hover": {
            color: autoenhance(this.themeProps.ERROR_COLOR),
        }
    }
}

@registerStyle(UserDashboardTabStyle)
export class UserDashboardTab extends UI.Element {
}
